pageId = 'page-two-factor-auth'
page = "##{ pageId }"

$ ->
  if $('.page:last').is(page)
    fetchQrcode()

fetchQrcode = ->
  $.ajax
    url: '/wechat/qrcode/?type=2'
    type: 'get'
    dataType: 'json'
    success: (result) ->
      if result.success
        $('img.qrcode').attr('src', result.qrcode_url)
        channel = tower.tempPusher(result.channel)

        channel.bind 'pusher:subscription_succeeded', ->
          $('.qrcode-wrap').removeClass('loading').find('.indicator').remove()
        .bind 'WECHAT_AUTH', (result) ->
          unless result.success
            simple.dialog.message
              content: result.message
            return

          data =
            signature: result.signature

          if $('input[name=trust_me]').is(':checked')
            data.trust_me = 'true'

          $.ajax
            url: @two_factor_auth_path
            type: 'post'
            data: data
            success: (result) ->
              if result.success
                location.href = result.target_url
